import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const scrollingShowcaseItemDefinition: ComponentDefinition = {
  id: 'scrolling-showcase-item',
  name: 'Showcase Logo',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/image.svg',
  variables: {
    image: {
      type: 'Media',
      displayName: 'Image',
      validations: {
        bindingSourceType: ['asset'],
      },
    },
    url: {
      type: 'Text',
      displayName: 'Link URL',
      defaultValue: '',
      group: 'content',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
  },
} as const;
